import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFiletypeUnknown = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg viewBox="0 0 41 50" className="block w-full h-full fill-current">
      <path
        d="M40.7 11.22L29.55.24a.825.825 0 00-.58-.24H8.4C5.29 0 2.77 2.66 2.77 5.94v21.92H.03v14.86h2.74v1.34C2.77 47.33 5.3 50 8.4 50h26.94c3.11 0 5.63-2.66 5.63-5.94V11.87c0-.24-.09-.48-.27-.65zM28.69 1.84l9.7 9.56h-5.28c-2.44 0-4.42-1.95-4.42-4.34V1.84zm10.58 42.22c0 2.29-1.76 4.15-3.93 4.15H8.4c-2.17 0-3.93-1.86-3.93-4.15v-1.34h18.7c3.65 0 6.6-3.33 6.6-7.43s-2.96-7.43-6.6-7.43H4.47V5.94c0-2.29 1.76-4.15 3.93-4.15h18.59v5.27c0 3.38 2.74 6.13 6.12 6.13h6.16"
        fill="currentColor"
      />
    </svg>,
  );
IconFiletypeUnknown.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFiletypeUnknown;
